import { MarketingActions } from "../../hooks/useMarketingActions";
import { PageContent } from "../../pages/templates/PageLayout";

import Images from "../images";

const content: PageContent = {
  style: "light",
  sections: [
    {
      type: "HeroSection",
      title: "Insights",
      style: "light",
      layoutDirection: "vertical",
      subtitle: "Measure the performance and impact of your assets with powerful analytics.",
      image: {
        src: Images.Product.insights_hero,
        alt: "",
      },
      primaryButton: {
        text: "Try lingo for free",
        link: "/signup",
      },
      secondaryButton: {
        text: "Book a demo",
        action: MarketingActions.BOOK_DEMO,
      },
    },
    {
      type: "MediaSection",
      title: "Optimize your brand",
      subtitle:
        "Use Insights to gain an understanding of what assets are engaging so you can fine tune your content creation",
      image: {
        src: Images.Product.insights_optimize,
        alt: "Optimize your brand with lingo insights",
      },
    },
    {
      type: "CtaSection",
    },
  ],
};
export default content;
